export default "__VITE_ASSET__uio5dEg7__"